import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getCoverDeviation,
  getCoverDeviationOffsetY,
} from '../../../selectors/deviations';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';

const mapStateToProps = (state: AppState) => {
  const coverDeviation = getCoverDeviation(state);
  const coverDeviationidOffsetY = getCoverDeviationOffsetY(state);
  return {
    coverDeviation,
    coverDeviationidOffsetY,
    isReducedHero: flagEnabled(state, 'profile_reduced_hero'),
  };
};

export default connect(
  mapStateToProps,
  {}
);
